import React from 'react';
import { Modal, Table } from 'antd';
import BookingTable from '../components/table';
import BookingStatusModal from 'common/components/booking-status-modal';
import { useBookingList } from './hooks';

export default function BookingList({ bookingJourneys }) {
  const {
    exportData,
    loading,
    orderColumns,
    exportColumns,
    exportVisible,
    statusModalVisible,
    exportLoading,
    tableData,
    filters,
    bookingId,
    stage,
    t,
    setVisible,
    setStatusModalVisible,
    handleTableChange,
    handleDownloadBooking,
    handleOnRowClick,
    handleStatusUpdated,
  } = useBookingList({ bookingJourneys });

  return (
    <div style={{ position: 'relative' }}>
      <BookingTable
        rowKey="referenceId"
        columns={orderColumns}
        list={tableData}
        loading={loading && !exportLoading}
        filters={filters}
        handleTableChange={handleTableChange}
        onRowClick={handleOnRowClick}
        scroll={{ x: 1500 }}
      />
      <Modal
        visible={exportVisible}
        width={820}
        bodyStyle={{ padding: '32px 60px' }}
        okButtonProps={{ icon: 'download', loading: exportLoading }}
        okText={t('cms.booking.modal.export.ok_btn')}
        onOk={handleDownloadBooking}
        onCancel={() => setVisible(false)}
        className="booking__modal-wrapper"
      >
        <header className="title">{t('cms.booking.export_data.title')}</header>
        <div className="subtitle">{t('cms.booking.export_data.subtitle')}</div>
        <section className="modal-content">
          <div className="export-header">
            <span className="available-export">{t('cms.booking.modal.header')}</span>
            <span className="bookings-count">
              {t('cms.booking.modal.export_count', { count: tableData?.totalCount })}
            </span>
          </div>
          <Table rowKey="id" dataSource={exportData} columns={exportColumns} />
        </section>
      </Modal>
      <BookingStatusModal
        id={bookingId}
        stage={stage}
        visible={statusModalVisible}
        onSuccess={handleStatusUpdated}
        onClose={() => setStatusModalVisible(false)}
      />
    </div>
  );
}
